module.exports = __webpack_public_path__ + "img/tmx_store_huawei_hillside_small.8513002e.jpg";